import React, { useState } from 'react';
import './HoldButton.scss';

interface HoldButtonProps {
  onPush?: () => void;
  onPushUp?: () => void;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

const HoldButton: React.FC<HoldButtonProps> = ({
  onPush,
  onPushUp,
  className = '',
  disabled = false,
  children,
}) => {
  const [active, setActive] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();
    const newActive = !active;
    setActive(newActive);
    if (newActive) {
      onPush && onPush();
    } else {
      onPushUp && onPushUp();
    }
  };

  return (
    <button
      className={`hold-button ${className}${active ? ' active' : ''}${disabled ? ' disabled' : ''}`}
      disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default HoldButton;
